import React from "react";

export const AreaBubbleIconLayout = () => {
    // let countTemplate = `{{ properties.customOptions.mainCount }}`;
    // let warningCarsTemplate = `{{ properties.customOptions.badge }}`;
    // let badgeSize = `{{ properties.customOptions.badgeSize }}`;
    let bg = `{{ properties.background }}`;
    let text = `{{ properties.iconContent }}`;
    return <div style={{
        border: "2px double #ffffff7d",
        display: "inline-block",
        boxSizing: "border-box",
        // justifyContent: "center",
        // alignItems: "center",
        backgroundColor: bg,
        borderRadius: "12px",
        paddingRight: "24px",
        paddingLeft: "24px",
        paddingTop: "2px",
        height: "24px"
    }}>
        <p style={{
            fontFamily: "YS Text",
            fontWeight: "bold",
            fontSize: "13px",
            margin: "auto",
            padding: "auto",
            // width: "100%",
            color: "#ffffff",
        }}>{text}</p>
    </div>
};